import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { TtOrderEvent, TtOrderMetadata } from "@/lib/api/risk/brokerage/tt";
import { canPreviewContract } from "./contractPreviewRules";

/**
 * Feature flag: while false the button always renders disabled with a
 * "coming back soon" tooltip, but the data flow is wired so flipping this
 * to true and supplying an onClick handler is the only change needed to
 * re-enable the contract preview functionality.
 */
const ENABLE_CONTRACT_PREVIEW = false;

interface ContractPreviewButtonProps {
  event: TtOrderEvent;
  metadata: TtOrderMetadata | null;
  guidOrderId: string;
}

export function ContractPreviewButton({
  event,
  metadata,
  // guidOrderId reserved for when we re-enable and need to pass it to the modal
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  guidOrderId,
}: ContractPreviewButtonProps) {
  // Only render the slot for events where preview would ever be meaningful
  // (Filled + HTA/OTC). Other event rows get nothing.
  if (!canPreviewContract(event, metadata)) {
    return null;
  }

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="inline-block">
            <Button
              variant="outline"
              size="sm"
              disabled={!ENABLE_CONTRACT_PREVIEW}
            >
              Preview Contract
            </Button>
          </span>
        </TooltipTrigger>
        <TooltipContent>
          {ENABLE_CONTRACT_PREVIEW
            ? "Open contract preview"
            : "Contract preview coming back soon"}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
